import React, { Component } from "react";
import { Route } from "react-router";
import { Layout } from "./components/Layout";

import "./custom.css";
import { TicketingPortal } from "./components/screens/TicketingPortal";
import { BuildingsPortal } from "./components/screens/BuildingsPortal";
import { ProposalAdmin } from "./components/ProposalAdmin";
import { ApprovedPackingList } from "./components/ApprovedPackingList";
import { UnapprovedPackingList } from "./components/UnapprovedPackingList";
import { ClientPortal } from "./components/screens/ClientPortal";
import { Login } from "./components/screens/Login";
import UserSetup from "./components/screens/UserSetup";
import { Dashboard } from "./components/Dashboard";
import { getCookie } from "./components/Util";
import { Support } from "./components/Support";
import { CheckedInMechanics } from "./components/screens/CheckedInMechanics";
import { Inspections } from "./components/InpsectionsItems/Inspections";
import { Alterations } from "./components/InpsectionsItems/Alterations";
import BrokenElevators from "./components/screens/BrokenElevators";
import { FollowUps } from "./components/FollowUps/FollowUps";

export default class App extends Component {
	static displayName = App.name;

	render() {
		const role = getCookie("role");
		return (
			<Layout>
				<Route path="/dashboard" component={Dashboard}></Route>
				<Route path="/clientportal" component={ClientPortal} />
				{role === "Admin" && (
					<>
						<Route path="/ticketingportal" component={TicketingPortal} />
						<Route path="/buildings" component={BuildingsPortal}></Route>
						<Route path="/proposaladmin" component={ProposalAdmin}></Route>
						<Route path="/packinglistapproved" component={ApprovedPackingList}></Route>
						<Route path="/packinglistunapproved" component={UnapprovedPackingList}></Route>
						<Route path="/usersetup" component={UserSetup}></Route>
						<Route path="/support" component={Support}></Route>
						<Route path="/login" component={Login}></Route>
						<Route path="/checkedin" component={CheckedInMechanics}></Route>
						<Route path="/inspections" component={Inspections}></Route>
						<Route path="/alterations" component={Alterations}></Route>
						<Route path="/brokenelevators" component={BrokenElevators}></Route>
						<Route path="/followups" component={FollowUps}></Route>
					</>
				)
				}
			</Layout>
		);
	}
}
